// Tárolja a project nevet a breadcrumbs számára
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProjectContextService {
  readonly projectName = signal<string | null>(null);

  set(name: string): void {
    this.projectName.set(name);
  }
  clear(): void {
    this.projectName.set(null);
  }
}
